import { Checkbox, MenuItem, Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import WushTextField from "../WushTextField";
import update from "../../../api/auth/reservations/reservationQuestions/reservationAnswers/update";
import create from "../../../api/auth/reservations/reservationQuestions/reservationAnswers/create";
import { useState } from "react";

export default function ReservationAnswer({ reservation, question }) {
  const [ answer, setAnswer ] = useState(question.answer?.answer === 'true' || question.answer?.answer === 't' || question.answer?.answer === true);
  const { register, handleSubmit } = useForm();

  const onSubmit = (values) => {
    if(question.answer) {
      update(reservation.id, question.id, question.answer.id, values, (response) => {
        console.log(response);
      });
    } else {
      create(reservation.id, question.id, values, (response) => {
        console.log(response);
      });
    }
  };

  const formRegistration = (onChange = false) => {
    return register('answer', { onBlur: handleSubmit(onSubmit), onChange: onChange && handleSubmit(onSubmit)});
  };

  console.log(question);

  const renderInput = () => {
    if(question.answer_data_type === 'text') {
      return (
        <WushTextField formRegistration={formRegistration()} label="Answer" defaultValue={question.answer?.answer} />
      );
    } else if(question.answer_data_type === 'number') {
      return (
        <WushTextField formRegistration={formRegistration()} label="Answer" type="number" defaultValue={question.answer?.answer}/>
      );
    } else if(question.answer_data_type === 'date') {
      return (
        <WushTextField formRegistration={formRegistration()} label="Answer" type="date" defaultValue={question.answer?.answer}/>
      );
    }
      else if(question.answer_data_type === 'acknowledgement') {
        return (
          <Checkbox
            checked={answer}
            onChange={() => {
              onSubmit({ answer: !answer });
              setAnswer(!answer);
            }}
          />
        );
    } else if(question.answer_data_type === 'boolean') {
      return (
        <WushTextField formRegistration={formRegistration(true)} label="Answer" select defaultValue={["t", "true", true].includes(question.answer?.answer)}>
          <MenuItem value={true}>Yes</MenuItem>
          <MenuItem value={false}>No</MenuItem>
        </WushTextField>
      );
    }
  };

  return (
    <Stack>
      <form onSubmit={handleSubmit(onSubmit)}>
        {renderInput()}
      </form>
    </Stack>
  );
}